import { useAppSelector } from "../../hooks/storeHooks";
import { selectRegimeMappings } from "../../store/selectors/defectSelectors";
import { Defect } from "../../types/defect";
import { formatRegimeCodes } from "../../utils/regimeMappingHelper";

/**
 * The regime (PSC) codes mapped to a defect's Idwal code — read-only, for the
 * reviewer's information. Derived from the defect's current `typeCode`, so
 * reassigning the code re-renders the row with the new mappings; nothing about
 * the mapping is stored against the defect.
 */
export const RegimeCodeBody = (defect: Defect) => {
    const mappings = useAppSelector(selectRegimeMappings);

    return <span>{formatRegimeCodes(defect.typeCode, mappings)}</span>;
};
